import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import ReactTooltip from 'react-tooltip';
import { useEventTracker } from '@applyboard/ui-utils';
import useInitialProps from "../../../hooks/useInitialProps";
import { formatDate, dateTimeFormat } from "../../../util/datetime";
import toUrl from "../../../util/toUrl";
import TextInput from "../../core/input/TextInput";
import AsyncButton from "../../core/button/AsyncButton";
import DropdownSelect from "../../core/input/DropdownSelect";
import CopyButton from "../../CopyButton";
import { _ButtonWrapper, _CustomFieldsEntry, _NewCustomField } from "../style";
var CustomFieldHolder = function CustomFieldHolder(_ref) {
  var attributes = _ref.attributes,
    copyValue = _ref.copyValue,
    filteredCustomFieldDefinitions = _ref.filteredCustomFieldDefinitions,
    edit = _ref.edit,
    editingEntry = _ref.editingEntry,
    onCancelEditing = _ref.onCancelEditing,
    _onChange = _ref.onChange,
    onChangeDefinition = _ref.onChangeDefinition,
    onKeyDown = _ref.onKeyDown,
    onRemove = _ref.onRemove,
    hasPermission = _ref.hasPermission,
    inContentSection = _ref.inContentSection,
    onDelete = _ref.onDelete,
    onSaveEdit = _ref.onSaveEdit,
    onSaveNew = _ref.onSaveNew,
    onStartEditing = _ref.onStartEditing;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var isNew = attributes === null || attributes === void 0 ? void 0 : attributes["new"];
  var definition = filteredCustomFieldDefinitions === null || filteredCustomFieldDefinitions === void 0 ? void 0 : filteredCustomFieldDefinitions.find(function (entry) {
    return entry.id === editingEntry.custom_field_definition_id;
  });
  var _setPermissionStrings = setPermissionStrings({
      attributes: attributes,
      definition: definition,
      inContentSection: inContentSection
    }),
    create_custom_field_permission = _setPermissionStrings.create_custom_field_permission,
    update_custom_field_permission = _setPermissionStrings.update_custom_field_permission,
    destroy_custom_field_permission = _setPermissionStrings.destroy_custom_field_permission;
  var hideABEmailCustomFieldButtons = !hasPermission('update_or_delete_email_and_password');
  var hideKeys = ['applyboard_email', 'applyboard_email_password'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, edit || isNew ? /*#__PURE__*/React.createElement(_NewCustomField, null, /*#__PURE__*/React.createElement("span", null, isNew ? /*#__PURE__*/React.createElement(DropdownSelect, {
    name: "custom_field_definition_id",
    onChange: onChangeDefinition,
    inputValue: editingEntry.custom_field_definition_id,
    options: buildOptions(filteredCustomFieldDefinitions)
  }) : attributes.display_name), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "value",
    inputValue: editingEntry.value,
    onChange: function onChange(e) {
      return _onChange('value', e.target.value);
    },
    onKeyDown: onKeyDown,
    placeholder: "Value"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    name: "url",
    inputValue: editingEntry.url,
    onChange: function onChange(e) {
      return _onChange('url', e.target.value);
    },
    onKeyDown: onKeyDown,
    placeholder: "URL"
  })), /*#__PURE__*/React.createElement("span", {
    className: "actions"
  }, /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    disabled: isNew && !hasPermission(create_custom_field_permission) || !isNew && !hasPermission(update_custom_field_permission),
    onClick: function onClick() {
      var _definition$attribute;
      trackEvent({
        event: 'Single Application - Application Details - Saved Custom Field',
        data: {
          applicationCurrentStage: application.current_stage,
          customFieldType: definition === null || definition === void 0 ? void 0 : (_definition$attribute = definition.attributes) === null || _definition$attribute === void 0 ? void 0 : _definition$attribute.display_name
        }
      });
      if (isNew) {
        onSaveNew();
      } else {
        onSaveEdit();
      }
    },
    ariaLabelText: "Save Custom Field"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "check"
  }))), isNew ? /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    buttonColor: "grey",
    buttonHover: "hoverGrey",
    onClick: function onClick() {
      var _definition$attribute2;
      trackEvent({
        event: 'Single Application - Application Details - Deleted Custom Field',
        data: {
          applicationCurrentStage: application.current_stage,
          customFieldType: definition === null || definition === void 0 ? void 0 : (_definition$attribute2 = definition.attributes) === null || _definition$attribute2 === void 0 ? void 0 : _definition$attribute2.display_name
        }
      });
      onRemove();
    },
    ariaLabelText: "Remove Custom Field"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "trash"
  }))) : /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    buttonColor: "red",
    buttonHover: "hoverRed",
    onClick: onCancelEditing,
    ariaLabelText: "Cancel Update Custom Field"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times"
  }))))) : /*#__PURE__*/React.createElement(_CustomFieldsEntry, null, /*#__PURE__*/React.createElement("span", {
    className: "custom-field-title"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "clock-o",
    "data-tip": formatDate(attributes.created_at, dateTimeFormat),
    "data-for": "tooltip-".concat(attributes.id)
  }), /*#__PURE__*/React.createElement("span", null, attributes.display_name)), /*#__PURE__*/React.createElement("span", {
    className: "value"
  }, attributes.value_type === 'url' || attributes.url && attributes.url !== '' ? /*#__PURE__*/React.createElement("a", {
    href: toUrl(attributes && attributes.url && attributes.url !== '' ? attributes.url : attributes.value),
    target: "_blank",
    rel: "noopener noreferrer"
  }, attributes.value !== '' ? attributes.value : attributes.url, ' ', /*#__PURE__*/React.createElement(FontAwesome, {
    name: "external-link"
  })) : attributes.value), /*#__PURE__*/React.createElement("span", {
    className: "actions"
  }, /*#__PURE__*/React.createElement(CopyButton, {
    label: copyValue,
    successMessage: "Copied ".concat(copyValue, " to clipboard")
  }), (!hideKeys.includes(attributes.key) || !hideABEmailCustomFieldButtons) && /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    disabled: !hasPermission(update_custom_field_permission),
    onClick: function onClick() {
      var _definition$attribute3;
      trackEvent({
        event: 'Single Application - Application Details - Updated Custom Field',
        data: {
          applicationCurrentStage: application.current_stage,
          customFieldType: definition === null || definition === void 0 ? void 0 : (_definition$attribute3 = definition.attributes) === null || _definition$attribute3 === void 0 ? void 0 : _definition$attribute3.display_name
        }
      });
      onStartEditing();
    },
    ariaLabelText: "Edit Custom Field"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "pencil-square-o"
  }))), (!hideKeys.includes(attributes.key) || !hideABEmailCustomFieldButtons) && /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    buttonColor: "grey",
    buttonHover: "hoverGrey",
    disabled: !hasPermission(destroy_custom_field_permission),
    onClick: function onClick() {
      var _definition$attribute4;
      trackEvent({
        event: 'Single Application - Application Details - Deleted Custom Field',
        data: {
          applicationCurrentStage: application.current_stage,
          customFieldType: definition === null || definition === void 0 ? void 0 : (_definition$attribute4 = definition.attributes) === null || _definition$attribute4 === void 0 ? void 0 : _definition$attribute4.display_name
        }
      });
      onDelete();
    },
    ariaLabelText: "Remove Custom Field"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "trash"
  }))))), /*#__PURE__*/React.createElement(ReactTooltip, {
    className: "custom-fields-tooltip",
    id: "tooltip-".concat(attributes.id)
  }));
};
function setPermissionStrings(_ref2) {
  var _definition$attribute5;
  var attributes = _ref2.attributes,
    definition = _ref2.definition,
    inContentSection = _ref2.inContentSection;
  var fieldType = attributes === null || attributes === void 0 ? void 0 : attributes.custom_fieldable_type;
  if (definition !== null && definition !== void 0 && (_definition$attribute5 = definition.attributes) !== null && _definition$attribute5 !== void 0 && _definition$attribute5.custom_field_type) {
    fieldType = definition.attributes.custom_field_type;
  }
  if (inContentSection && fieldType === 'student') {
    return {
      create_custom_field_permission: 'create_custom_field_student',
      update_custom_field_permission: 'update_custom_field_student',
      destroy_custom_field_permission: 'destroy_custom_field_student'
    };
  }
  if (inContentSection && fieldType === 'application') {
    return {
      create_custom_field_permission: 'create_custom_field_application',
      update_custom_field_permission: 'update_custom_field_application',
      destroy_custom_field_permission: 'destroy_custom_field_application'
    };
  }
  return {
    create_custom_field_permission: 'create_custom_field',
    update_custom_field_permission: 'update_custom_field',
    destroy_custom_field_permission: 'destroy_custom_field'
  };
}
function buildOptions(options) {
  var returnValue = [];
  if (!options) return returnValue;
  var mapFunction = function mapFunction(definition) {
    return {
      value: definition.id,
      label: definition.attributes.display_name
    };
  };
  var studentOptions = options.filter(function (entry) {
    return entry.attributes.custom_field_type === 'student';
  }).map(mapFunction);
  if (studentOptions.length > 0) {
    returnValue.push({
      label: 'Student',
      options: studentOptions
    });
  }
  var applicationOptions = options.filter(function (entry) {
    return entry.attributes.custom_field_type === 'application';
  }).map(mapFunction);
  if (applicationOptions.length > 0) {
    returnValue.push({
      label: 'Application',
      options: applicationOptions
    });
  }
  return returnValue;
}
export default CustomFieldHolder;